module.exports = __webpack_public_path__ + "static/media/marker_bus_stop.014cabca.svg";